<app-modal
  [title]="ticketNumber() || dictionary.get('Ticket')"
  [(opened)]="modalOpened"
  (closeTrigger)="handleClose()"
  size="xxl"
  [noGap]="true"
>
  @if (loading()) {
    <div class="loading-state">{{ dictionary.get("LoadingConversation") }}</div>
  } @else {
    @if (ticket(); as currentTicket) {
      <div class="ticket-shell">
        <header class="ticket-summary">
          <div class="ticket-summary-copy">
            <h3>{{ currentTicket.title }}</h3>
            <div class="ticket-summary-details">
              <p
                [attr.title]="
                  currentTicket.description ||
                  dictionary.get('NoTicketDescription')
                "
              >
                {{
                  currentTicket.description ||
                    dictionary.get("NoTicketDescription")
                }}
              </p>
              <div class="metadata">
                <span>{{ dictionary.get(currentTicket.category) }}</span>
                <span>{{ dictionary.get(currentTicket.priority) }}</span>
                <span class="status" [attr.data-status]="currentTicket.status">
                  {{ dictionary.get(currentTicket.status) }}
                </span>
              </div>
            </div>
          </div>
        </header>

        @if (pollError()) {
          <div class="poll-warning">
            {{ dictionary.get("TicketPollingRetry") }}
          </div>
        }

        <app-ticket-message-list
          [messages]="messages()"
          [senderRole]="ticketSenderRole.USER"
          [currentSenderId]="currentSenderId()"
          [currentSenderName]="currentSenderName()"
          [senderLabel]="translateSender"
          [mediaUrl]="resolveMediaUrl"
          [emptyLabel]="dictionary.get('NoMessagesYet')"
          [sentLabel]="dictionary.get('Sent')"
          [readLabel]="dictionary.get('Read')"
          [seeMoreLabel]="dictionary.get('SeeMore')"
          [seeLessLabel]="dictionary.get('SeeLess')"
          [openLabel]="dictionary.get('OpenAttachment')"
          [downloadLabel]="dictionary.get('Download')"
          (imageOpen)="openImageAttachment($event)"
          (documentOpen)="openDocumentAttachment($event)"
          (contentSizeChange)="contentSizeChanged()"
          (stickToBottomChange)="setStickToBottom($event)"
        />

        @if (currentTicket.status === ticketStatus.CLOSED) {
          <div class="closed-banner">
            {{ dictionary.get("TicketClosedMessage") }}
          </div>
        } @else {
          <app-ticket-reply-composer
            [sending]="sending()"
            [labels]="composerLabels()"
            (submitted)="send($event)"
            (validationError)="showFileSelectionError($event)"
            (previewFailed)="attachmentPreviewFailed()"
          />
        }
      </div>
    }
  }
</app-modal>

<app-ticket-attachment-preview
  [downloadLabel]="dictionary.get('Download')"
  [closeLabel]="dictionary.get('ClosePreview')"
  [loadingLabel]="dictionary.get('LoadingAttachmentPreview')"
  [sheetLabel]="dictionary.get('SpreadsheetSheet')"
  [emptySheetLabel]="dictionary.get('SpreadsheetEmptySheet')"
  [truncatedLabel]="dictionary.get('SpreadsheetPreviewTruncated')"
  (closed)="attachmentPreviewClosed()"
  (failed)="attachmentPreviewFailed()"
/>
